<template>
  <div class="page page-supply-info-bankcard input-page">
    <div class="info-list">
      <div class="bankcard-img" @click="chooseImage">
        <img class="img" v-if="bankCardUrl" :src="bankCardUrl" />
        <img class="img" v-else src="~@/assets/img/icon_xj.png" />
        <div class="txt">银行卡正面</div>
      </div>
      <div class="info-item">
        <div class="label">银行卡号</div>
        <div class="value">
          <input
            class="input"
            v-model="form.bankCardNum"
            placeholder="请输入本人银行卡号"
          />
        </div>
      </div>
      <div class="info-item">
        <div class="label">手机号</div>
        <div class="value">
          <input
            class="input"
            v-model="form.tel"
            placeholder="请输入手机号"
          />
        </div>
      </div>
      <div class="info-item">
        <div class="label">验证码</div>
        <div class="value">
          <input
            class="input"
            v-model="form.captcha"
            placeholder="请输入验证码"
          />
          <div class="code" @click="sendMessage">{{ captchInfo.txt }}</div>
        </div>
      </div>
    </div>
    <!-- 提交按钮 -->
    <div class="homecustom-btn">
      <van-button
        type="primary"
        :color="canSubmit ? '#FFA543' : '#FFCE98'"
        @click="onSubmit"
        block
      >
        提交
      </van-button>
    </div>

    <van-toast id="van-toast" />
    <van-dialog confirm-button-color="#5280FE" id="van-dialog" />
  </div>
</template>

<script>
import { updateBankCard, sendMessage, verifyBankCard } from '@/api/common'
import { chooseImage } from '@/common/oss'

export default {
  data() {
    return {
      bankCardUrl: '', // 银行卡url
      bankCardUrlShow: '',
      form: {
        bankCardNum: '', //银行卡号
        tel: '', //手机号
        captcha: '' //验证码
      },
      captchInfo: {
        txt: '获取验证码',
        timer: '',
        second: 60,
        disabled: false
      }
    }
  },
  computed: {
    canSubmit() {
      return this.form.bankCardNum && this.form.tel && this.form.captcha
    }
  },

  created() {},
  methods: {
    sendMessage() {
      if (!this.form.tel) {
        return this.$toast('请输入手机号')
      }
      if (this.captchInfo.disabled) {
        return
      }
      this.captchInfo.disabled = true
      sendMessage({
        serviceName: 'worth',
        type: 'updatepassword',
        mobile: this.form.tel
      })
        .then(res => {
          this.$toast('验证码发送成功')
          this.captchInfo.timer = setInterval(() => {
            this.captchInfo.second--
            this.captchInfo.txt = `${this.captchInfo.second}s`
            if (this.captchInfo.second == 1) {
              this.captchInfo.txt = '获取验证码'
              this.captchInfo.disabled = false
              this.captchInfo.second = 60
              clearInterval(this.captchInfo.timer)
            }
          }, 1000)
        })
        .catch(err => {
          this.captchInfo.disabled = false
        })
    },
    chooseImage() {
      chooseImage({
        count: 1,
        fileMaxSize: ''
      }).then(res => {
        this.bankCardUrl = res[0] || ''
        this.verifyBankCard()
      })
    },
    verifyBankCard() {
      verifyBankCard({
        bankcardFront: this.bankCardUrl
      })
        .then(res => {
          this.form.bankCardNum = res.bankCardNo
        })
        .catch(err => {
          this.form.bankCardNum = ''
        })
    },
    // 提交
    onSubmit() {
      // 商户个人信息
      if (!this.bankCardUrl) {
        return this.$toast('请上传银行卡照片')
      }
      if (!this.form.tel) {
        return this.$toast('请输入手机号')
      }
      if (!this.form.captcha) {
        return this.$toast('请输入验证码')
      }
      let accountType = localStorage.getItem('accountType') || ''
      updateBankCard({
        ...this.form,
        accountType: parseInt(accountType)
      }).then(res => {
        this.$toast('提交成功')
        setTimeout(() => {
          // SyHybridSdk.closeWebView({
          //   params: {},
          //   success: res => {}
          // })
          this.$router.replace({
            path: '/supply-info/index'
          })
        }, 1000)
      })
    }
  }
}
</script>
